import { TYPE_LOGOUT, TYPE_LOGOUT_SOFT } from 'constants/Login';

const INIT_STATE = null;
const INIT_ACTION_TYPE = '@@INIT';
const logoutTypes = [TYPE_LOGOUT, TYPE_LOGOUT_SOFT];

const reduceStart = state => state + 1;
const reduceFinish = state => state - 1;
const reduce = (state, set) => (set ? reduceStart(state) : reduceFinish(state));
const createReducer = (
  onTypes: string[],
  offTypes: string[],
  resetOnLoad = false,
  resetOnLogout = false,
) => (state = INIT_STATE, { type }) => {
  if (resetOnLoad && type === INIT_ACTION_TYPE) {
    return INIT_STATE;
  }
  if (resetOnLogout && logoutTypes.includes(type)) {
    return INIT_STATE;
  }
  if (onTypes.includes(type)) {
    return reduceStart(state);
  }
  if (offTypes.includes(type)) {
    return reduceFinish(state);
  }
  return state;
};
const getIsLoading = (state = 0) => state > 0;
const getIsInitState = state => Object.is(INIT_STATE, state);

export default {
  reduce,
  reduceStart,
  reduceFinish,
  createReducer,
  getIsLoading,
  getIsInitState,
  initState: INIT_STATE,
};
